import { Col, Row } from "react-bootstrap"
import styles from './User.module.css'
import Checkbox from "../../../../../../components/checkbox/Checkbox"
import { modifyUserData } from "../Users"

export type UserType = {
    id: number
    username: string
    enabled: boolean
}

interface userPropsInterface {
    odd: boolean
    user: UserType
    modifyUser: (userId: number, data: modifyUserData) => Promise<void>
}

export default function User({ odd, user, modifyUser }: userPropsInterface) {
    return(
        <>
            <Row style={odd ? {backgroundColor: "rgb(0, 0, 0, 0.1)"} : {backgroundColor: "rgb(0, 0, 0, 0.3)"} } className={styles.containerBody}>

                <Col sm="4">{user.id}</Col>

                <Col sm="4">{user.username}</Col>

                <Col sm="4" style={{justifyItems:"center"}}>
                    <Checkbox
                        id={ `user-${ user.id }-enabled` }
                        name='enabled'
                        checked={ user.enabled }
                        onChange={ e => {
                            e.preventDefault()

                            const enabled = e.target.checked
                            modifyUser(user.id, { enabled })
                        }}
                    />
                </Col>
            </Row>
        </>
    )
}